import * as React from 'react';
import * as styles from './styles.css';

interface ITitleProps {
  houseTitle: string;
  sectionTitle: string;
}

export const Title = ({ houseTitle, sectionTitle }: ITitleProps) => {
  return (
    <strong className={styles['title']}>
      {houseTitle} · {sectionTitle}
    </strong>
  );
};
